const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const {DEFAULT_BUNDLE_GRADE} = require("shared/Constants");
const StringUtil = require("shared/StringUtil");
const AT = require("src/core/vault/ActionTypes");
const OpsParentSubChange = require("src/parent/vault/OpsParentSubChange");
const StoreUtil = require("shared/StoreUtil");
const {getFeatureFlag} = require("src/core/util/FeatureFlags");
const Input = require("src/office/checkout/Input");
const RadioItem = require("src/office/RadioItem");
const InfoIcon = require("src/office/InfoIcon");
const UnderlineView = require("src/office/UnderlineView");
const CopyTable = require("src/office/data/CopyTable");
const SubscriptionSummaryAccount = require("src/parent/account/SubscriptionSummaryAccount");
const AssetsUtil = require("src/core/util/AssetsUtil");
const BookstoreUtil = require("shared/BookstoreUtil");
const Dropdown = require("src/core/view/DropdownSelect");
const OpsCart = require("src/office/vault/OpsCart");
const {track} = require("src/core/util/Mixpanel");
const styles = require("./styles/ChooseSubscription.css");

module.exports = createReactClass({
	displayName: "ChooseSubscription",

	propTypes: {
		account: PT.object.isRequired,
		onContinue: PT.func.isRequired,
		dispatch: PT.func.isRequired,
		changeType: PT.string.isRequired,
	},

	setSelectedPlanType: function(value) {
		this.props.dispatch({
			type: AT.SUBSCRIPTION_CHANGE_SET_PLAN_TYPE,
			value,
		});
	},

	getSelectedPlanType: function() {
		return _.get(this.props.account, ["subChangeState", "newPlanType"], null);
	},

	setSelectedBundleGrades: function(value) {
		this.props.dispatch({
			type: AT.SUBSCRIPTION_CHANGE_SET_BUNDLE_GRADES,
			value: _.compact(value),
		});
	},

	setNewDisplayName: function(value) {
		this.props.dispatch({
			type: AT.SUBSCRIPTION_CHANGE_SET_DISPLAY_NAME,
			value,
		});
	},

	setBookLevelDeferred: function(value) {
		this.props.dispatch({
			type: AT.SUBSCRIPTION_CHANGE_SET_BOOK_LEVEL_DEFERRED,
			value,
		});
	},

	renderDefermentOption: function(label, desc, deferred, isSelected) {
		const labelNode = (
			<span className={styles.defermentOptionText}>
				<span className={styles.defermentOptionTitle}>{label}</span>
				<span className={styles.defermentOptionDesc}>{desc}</span>
			</span>
		);
		return (
			<div className={styles.defermentOption} key={label}>
				<RadioItem
					className={styles.defermentRadioItem}
					size={"small"}
					isSelected={isSelected}
					onClick={() => this.setBookLevelDeferred(deferred)}
					text={labelNode}
				/>
			</div>
		);
	},

	getPreview: function(selected) {
		let previewStr = "";
		if (!selected.length) {
			const displayName = OpsParentSubChange.getDisplayName(this.props.account);
			return displayName
				? `Select bundle(s) for ${displayName}`
				: `Select bundle(s)`;
		} else {
			previewStr = OpsCart.getMultiBundleName(selected);
		}
		return previewStr;
	},

	// guarantees an array with at least 1 grade number
	getSelectedBundleGradeNumbers: function() {
		const {account} = this.props;
		const selectedGrades = account.subChangeState.bundleGrades;
		const grades =
			selectedGrades?.length > 0 ? selectedGrades : [DEFAULT_BUNDLE_GRADE];
		return grades;
	},

	// guarantees an array with at least 1 bundle ID
	getSelectedBundleIDs: function() {
		const grades = this.getSelectedBundleGradeNumbers();
		return _.map(grades, grade => `bundle-grade-${grade}`);
	},

	renderOptionPrice: function(
		option,
		mobileDiscountOnly,
		{current, upgradePrice, subPrice}
	) {
		const {account, changeType} = this.props;
		const isUpgrade = changeType === "upgrade";
		const isDisabled = current === option;
		if (option === "bundle" && !isUpgrade) {
			if (mobileDiscountOnly) return null;
			const bundlePrice = StoreUtil.calculateBundlePrice(
				this.getSelectedBundleIDs()[0]
			).total;
			return (
				<div className={styles.rightRadio}>
					<div className={styles.price}>
						{StringUtil.toPrice(bundlePrice)}
						/bundle
					</div>
				</div>
			);
		}
		const priceSuffix = "/" + option.replace("ly", "");
		const isHighlighted =
			(this.isSecondaryPricing(option) && !(isUpgrade && isDisabled)) ||
			(isUpgrade && !isDisabled);

		let priceDiscount, mobileAsterisk, prevPaid, finalPrice;
		if (isUpgrade && !isDisabled) {
			const priceInfo = OpsParentSubChange.getPricesForAll(account);
			const priceType = OpsParentSubChange.getPricesLoadKey(
				option,
				this.getSelectedBundleGradeNumbers()
			);
			const estPrice = _.get(priceInfo, [priceType, "totals", "subtotal"]);
			if (estPrice) {
				finalPrice = (
					<div className={styles.upgradePrice}>
						{StringUtil.toPrice(estPrice)} upgrade
					</div>
				);
			}
		} else {
			priceDiscount = this.renderOptionDiscount(option, mobileDiscountOnly);
			mobileAsterisk = isUpgrade ? null : (
				<span className={styles.mobileAsterisk}>*</span>
			);
		}
		let priceStyle = styles.price;
		if (isHighlighted) {
			priceStyle = styles.priceCrossedOut;
		}
		return (
			<div className={styles.rightRadio}>
				<div className={priceStyle}>
					{StringUtil.toPrice(subPrice) + priceSuffix}
					{mobileAsterisk}
				</div>
				{prevPaid}
				{finalPrice}
				{priceDiscount}
			</div>
		);
	},

	// Determines if there are other active subs of the same plan type
	// which would mean there's discounted (secondary student) pricing
	// but we also have to check if the user has changed their subscription
	// and if so if that previous subscription has yet to expire
	// if it hasn't expired, the new subscription hasn't taken effect
	// yet and they should not get discounted pricing
	isSecondaryPricing: function(option) {
		const {account} = this.props;
		const students = _.get(account, "students", []);
		return _.some(students, s => {
			const isActive =
				_.get(account, "subChangeState.studentID") !== s.userID &&
				_.get(s, ["subscription", "active"], false) === true;
			const effectivePlanType = _.get(s, ["subscription", "effectivePlanType"]);
			const hasSamePlan =
				effectivePlanType === option ||
				(option === "yearly" && effectivePlanType === "bundle");
			return isActive && hasSamePlan;
		});
	},

	renderOptionDiscount: function(option, mobileDiscountOnly) {
		const {account, changeType} = this.props;
		if (mobileDiscountOnly && option === "bundle") return null;
		if (changeType === "upgrade") return null;
		const renewPrices = OpsParentSubChange.getRenewPrices(account, option);
		const subPriceDiscount = renewPrices && renewPrices[1];
		const priceSuffix = "/" + option.replace("ly", "");
		let mainClassName = mobileDiscountOnly
			? styles.priceDiscountMobile
			: styles.priceDiscount;
		if (this.isSecondaryPricing(option)) {
			mainClassName += " " + styles.discountHighlight;
		}

		return (
			<div className={mainClassName}>
				<span className={styles.mobileAsterisk}>*</span>
				{"Additional students for " +
					StringUtil.toPrice(subPriceDiscount) +
					priceSuffix +
					"."}
			</div>
		);
	},

	renderOption: function(option, current) {
		const {account, changeType} = this.props;
		const selectedOption = account.subChangeState.newPlanType;
		const selectedGrades = account.subChangeState.bundleGrades;

		const isSelected = selectedOption === option;
		const isDisabled = current === option;
		const isUpgrade = changeType === "upgrade";

		const gradeSets = BookstoreUtil.getAvailableGradeSets().filter(
			element => !/^\dS$/.test(element)
		); // Don't show a bundle for Science books.
		const gradeOptions = _.zipObject(
			gradeSets,
			gradeSets.map(g => "BA " + g + ": " + g + "A-" + g + "D + 1yr online")
		);
		let gradeSelectEl = null;
		if (option === "bundle") {
			const containerClass = isSelected
				? styles.gsContainer
				: styles.gsContainerHidden;
			const gradeInfoClass = isSelected ? styles.info : styles.infoHidden;
			const dropdownEl = (
				<Dropdown
					className={styles.gradeSelect}
					defaultOption={"Select bundle"}
					initialValue={selectedGrades && selectedGrades[0]}
					options={gradeOptions}
					updateSelection={sel => this.setSelectedBundleGrades([sel])}
					optionHeight={36}
					errorText={""}
				/>
			);
			const showDeferment =
				!isUpgrade &&
				this.props.changeType === "add" &&
				(selectedGrades || []).length <= 1 &&
				getFeatureFlag("ENABLE_BA_BUNDLE_DEFERMENT");
			const isDeferred = OpsParentSubChange.getBookLevelDeferred(account);
			track("Enrollment Add Subscription Page Viewed", {
				page: "enroll",
				showDeferment: showDeferment,
			});
			gradeSelectEl = (
				<div className={styles.gradeSelectWrapper}>
					<div className={containerClass}>
						{dropdownEl}
						<InfoIcon
							title={"Select a Bundle"}
							text={CopyTable.getBundleSelectionCopy()}
							className={gradeInfoClass}
							isModal={true}
						/>
					</div>
					{showDeferment && isSelected && (
						<div className={styles.defermentOptions}>
							<div className={styles.defermentLabel}>
								{"When should we ship your books?"}
							</div>
							{this.renderDefermentOption(
								"Confirm books now",
								"We'll begin processing your order today",
								false,
								!isDeferred
							)}
							{this.renderDefermentOption(
								"Take placement test first",
								"Take test during onboarding. You'll have 48 hours to update or confirm your books.",
								true,
								isDeferred
							)}
						</div>
					)}
				</div>
			);
		}

		let upgradePrice = 0;
		let subPrice = 0;
		let numBooks = 8;
		// NOTE: for now we can assume all bundles are the same price
		const bundleID = this.getSelectedBundleIDs()[0];
		const bundlePrice = StoreUtil.calculateBundlePrice(bundleID).total;
		const bundleBookPrice = StoreUtil.calculateBundlePrice(bundleID, true)
			.books;
		const yearlyPricePerMonth = StoreUtil.calculateOneItemPrice({
			sku: "beast-yearly",
			quantity: 1,
		})
			.price.div(12)
			.round(2, 3);
		if (option === "bundle") {
			subPrice = bundlePrice;
			numBooks = StoreUtil.getBookSKUsForBundleID(bundleID).length;
		} else {
			const renewPrices = OpsParentSubChange.getRenewPrices(account, option);
			subPrice = renewPrices[0];
		}
		let upgradeInfo = {};
		if (isUpgrade && !isDisabled) {
			upgradeInfo = OpsParentSubChange.getUpgradeInfo(account, option);
			upgradePrice = upgradeInfo.upgradePrice;
		}
		let optionClass = isSelected ? styles.selectedOption : styles.option;
		const optionText = CopyTable.getChooseSubscriptionsCopy(
			_.extend(
				{
					upgradePrice,
					numBooks,
					bundlePrice,
					bundleBookPrice,
					yearlyPricePerMonth,
				},
				upgradeInfo
			)
		);
		let tagline = optionText[option].tagline;
		let onSelectPlan = () => this.setSelectedPlanType(option);
		if (isDisabled) {
			tagline = optionText.disabledTagline;
			optionClass += " " + styles.disabled;
			onSelectPlan = null;
		} else if (isUpgrade) {
			tagline = optionText[option][current + "Upgrade"];
		}
		return (
			<div className={optionClass} key={option} onClick={onSelectPlan}>
				<div className={styles.radioGroup}>
					<div className={styles.leftRadio}>
						<RadioItem
							className={styles.radio}
							text={_.capitalize(option)}
							isSelected={isSelected}
							size={"large"}
							isDisabled={isDisabled}
							onClick={onSelectPlan}
						/>
						<div className={styles.description}>{tagline}</div>
					</div>
					{this.renderOptionPrice(option, false, {
						current,
						subPrice,
						upgradePrice,
					})}
				</div>
				<div className={styles.descriptionMobile}>{tagline}</div>
				{gradeSelectEl}
				{this.renderOptionDiscount(option, true)}
			</div>
		);
	},

	render: function() {
		const {account, changeType} = this.props;

		const {types, current} = OpsParentSubChange.getValidPlanTypes(account);

		const options = types.map(t => this.renderOption(t, current));

		const scs = account.subChangeState;

		let note = null;
		const subscription = OpsParentSubChange.getCurrentSubscription(account);
		if (subscription && subscription.active && changeType !== "upgrade") {
			note = (
				<div className={styles.note}>
					{CopyTable.getChangeSubscriptionNote(subscription)}
				</div>
			);
		}

		let noNameOnSummary = false;
		let title = "Subscription Type";

		let nameEntryEl;
		const displayNameCopy = CopyTable.getDisplayNameCopy();
		if (OpsParentSubChange.canSetDisplayName(account)) {
			noNameOnSummary = true;
			title = "Subscription Information";
			nameEntryEl = (
				<div className={styles.nameContainer}>
					<img className={styles.nameImg} src={AssetsUtil.getOfficeAvatar(1)} />
					<Input
						className={styles.name}
						placeholder={displayNameCopy.placeholder}
						initialValue={OpsParentSubChange.getDisplayName(account)}
						onUpdate={this.setNewDisplayName}
						updateOnEdit={true}
						checkType={"displayName"}
						showErrorType={scs.displayNameError}
						errorCanWrap={true}
						placeholderInside={true}
					/>
					<InfoIcon
						title={displayNameCopy.title}
						text={displayNameCopy.info}
						className={styles.info}
						isModal={true}
					/>
				</div>
			);
		}

		const selectedPlan = this.getSelectedPlanType();
		const renewPrices = OpsParentSubChange.getRenewPrices(
			account,
			selectedPlan
		);
		const subPriceDiscount = selectedPlan && renewPrices && renewPrices[1];
		const studentsWithSamePlan = _.filter(
			this.props.account.students,
			s => s.subscription.active && s.subscription.planType === selectedPlan
		);

		const prices = OpsParentSubChange.getPrices(account);

		const isProrated =
			selectedPlan &&
			selectedPlan === "monthly" &&
			studentsWithSamePlan.length &&
			prices &&
			_.get(prices, ["totals", "subtotal"], 0.0) !== subPriceDiscount;
		// If a parent has an active yearly or monthly subscription then
		// the expiration date for subsequent subscriptions are all the
		// same as the first so it doesn't matter which one we use
		// to get the expiration date
		const prorateStudent = _.head(studentsWithSamePlan);
		const prorateInfo = {
			selectedPlan: selectedPlan || null,
			isProrated,
			expiresAt: _.isEmpty(prorateStudent)
				? null
				: prorateStudent.subscription.expiresAt,
		};
		return (
			<div className={styles.main}>
				<div className={styles.title}>
					<UnderlineView text={title} />
				</div>
				{note}
				<div className={styles.across}>
					<div className={styles.options}>
						{nameEntryEl}
						{options}
					</div>
					<SubscriptionSummaryAccount
						account={account}
						showItemize={true}
						hideSubNames={noNameOnSummary}
						onContinue={this.props.onContinue}
						buttonText={"Continue"}
						isProrated={isProrated}
						prorateInfo={prorateInfo}
					/>
				</div>
			</div>
		);
	},
});
